import { render, staticRenderFns } from "./BeefCattleModal.vue?vue&type=template&id=c0605358"
import script from "./BeefCattleModal.vue?vue&type=script&lang=js"
export * from "./BeefCattleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports